import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Stack } from "@mui/material";

import { InterestType } from "../types";
import { OptionCard } from "../OptionCard";
import { QuestionSlot } from "../QuestionSlot";

interface Step3Props {
  interestType: InterestType | null;
  setInterestType: (v: InterestType) => void;
}

export const Step3InterestType: React.FC<Step3Props> = ({ interestType, setInterestType }) => {
  const { t } = useTranslation("debt");

  return (
    <Box>
      <QuestionSlot visible label={t("wizard.interestType.question")}>
        <Stack spacing={2}>
          {([
            ["regular", t("wizard.interestType.regular"), t("wizard.interestType.regularDesc")],
            ["pik",     t("wizard.interestType.pik"),     t("wizard.interestType.pikDesc")],
            ["both",    t("wizard.interestType.both"),    t("wizard.interestType.bothDesc")],
            ["none",    t("wizard.interestType.none"),    t("wizard.interestType.noneDesc")]
          ] as [InterestType, string, string][]).map(([v, title, subtitle]) => (
            <OptionCard
              key={v}
              value={v}
              selected={interestType === v}
              onSelect={(val) => setInterestType(val as InterestType)}
              title={title}
              subtitle={subtitle}
            />
          ))}
        </Stack>
      </QuestionSlot>
    </Box>
  );
};
